var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5H15V7.5H5V5Z",
    fill: "#373737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5H3.5V7.5H1V5Z",
    fill: "#373737"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11H3.5V13.5H1V11Z",
    fill: "#373737"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17H3.5V19.5H1V17Z",
    fill: "#373737"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11H19V13.5H5V11Z",
    fill: "#373737"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17H23V19.5H5V17Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.2c8bab33c085e71f8fd825a2465e66cd.svg";
export { ForwardRef as ReactComponent };